module.exports = __webpack_public_path__ + "media/icons/skrzynia-manualna-blue-2db8d10e.png";